import dayjs from 'dayjs';
import StudyReportItem from '../types/StudyReportItem';

/** File name (without extension) for a downloaded report: "<title>_<YYYY-MM-DD>". */
const buildReportFileName = (report: StudyReportItem): string => {
  const title =
    report.title
      .replace(/\.pdf$/i, '')
      .replace(/[\\/:*?"<>|]+/g, ' ')
      .trim() || 'Reporte';
  const date = report.createdAt ? dayjs(report.createdAt) : undefined;
  return date?.isValid() ? `${title}_${date.format('YYYY-MM-DD')}` : title;
};

export default buildReportFileName;
